import * as React from "react";
import styled from "styled-components";
import { Delete24Regular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";
import { CharacterCommandsButton } from "./CharacterCommandsButton";
export interface CharacterProps {
  name?: string;
  id?: number;
  color?: string;
  clearSingleTokenAndCharacter: () => void;
}

const CharacterBoxWrap = styled.div`
  padding: 5px;
  padding-top: 1px;
  padding-bottom: 1px;
  width: calc(100% - 10px);
  max-width: 100%;
  margin-top: 5px;
  display: flex;
  position: relative;
`;
const CharacterBoxName = styled.div`
  color: #000;
  font-family: "ShentoxRegular";
  display: flex;
  font-size: max(15px, min(5vw, 22px));
  line-height: 1.1em;
  text-align: left;
  margin-right: 40px;
`;
const CharacterBoxImage = styled.div`
  padding-bottom: 0;
  margin-right: 8px;
  img {
    height: 80px;
    border-radius: 5px;
  }
`;

const CharacterInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 5px;
  align-items: baseline;
`;
export default function CharacterBox(Props: CharacterProps) {
  let CharacterID: number = 1;
  if (Props.id) CharacterID = Props.id;

  return (
    <>
      <CharacterBoxWrap>
        <CharacterBoxImage>
          <img
            src={`https://images.evetech.net/characters/${CharacterID}/portrait?tenant=tranquility&size=256`}
            alt={`Character portrait of '${Props.name}'`}
          />
        </CharacterBoxImage>
        <CharacterInfoWrap>
          <CharacterBoxName className="CharacterName">{Props.name}</CharacterBoxName>
          {CharacterID > 1 && <CharacterCommandsButton character_id={CharacterID} />}
        </CharacterInfoWrap>
        {CharacterID > 1 && (
          <Button
            icon={<Delete24Regular />}
            title="Remove character"
            onClick={() => Props.clearSingleTokenAndCharacter()}
            style={{ position: "absolute", right: 5 }}
          />
        )}
      </CharacterBoxWrap>
    </>
  );
}
